module.exports = __webpack_public_path__ + "27a6cee2843c5c4967e21e26b90aeb35.svg";